module.exports = __webpack_public_path__ + "img/30-None of these.c12bf56c.png";